// Thin bridge between apiClient's tracedFetch and the telemetry recorder.
// Lives in its own module so apiClient's static import never touches
// recorder state at module-init time, and so the skip-list (telemetry's own
// endpoints) has exactly one home.

import { recorder } from './recorder';

const SKIP_SUBSTRINGS = ['/telemetry/', '/monitoring/client-errors'];

export function traceApiCall(url: string, method: string, status: number, ms: number): void {
  try {
    if (!url || SKIP_SUBSTRINGS.some((s) => url.includes(s))) return;
    recorder.recordApi(url, method, status, ms);
  } catch {
    // tracing must never affect the request path
  }
}

// Streaming (XHR/NDJSON) calls bypass apiClient's tracedFetch, so the five
// stream* modules hold one of these handles per request. `firstByte()` is
// called from the first onprogress (time-to-first-token — the number that IS
// perceived chat latency); `done(status)` from onload/onerror/ontimeout.
// Deliberately NOT called on user-initiated abort — a cancelled stream is not
// a latency sample. Both methods are idempotent and swallow everything.
export interface StreamTraceHandle {
  firstByte: () => void;
  done: (status: number) => void;
}

export function traceStreamCall(kind: string): StreamTraceHandle {
  const startedAt = Date.now();
  let ttfbMs: number | null = null;
  let finished = false;
  return {
    firstByte: () => {
      if (ttfbMs === null) ttfbMs = Date.now() - startedAt;
    },
    done: (status: number) => {
      if (finished) return;
      finished = true;
      try {
        recorder.recordStream(kind, status, Date.now() - startedAt, ttfbMs);
      } catch {
        // tracing must never affect the stream
      }
    },
  };
}
